import React from 'react';
import { Tag } from 'antd';

export enum IncidentEventType {
	Downtime = 'Downtime'
}

const incidentEventText = {
	[ IncidentEventType.Downtime ]: 'Downtime'
};

const incidentEventColor = {
	[ IncidentEventType.Downtime ]: 'red'
};

export interface IncidentEventTypeTagProps {
	eventType: IncidentEventType;
}

export const IncidentEventTypeTag: React.FC<IncidentEventTypeTagProps> = ({ eventType }) =>
	<Tag
		color={ incidentEventColor[ eventType ] }>
		{ incidentEventText[ eventType ] }
	</Tag>;

